import React from "react";

import styled from "styled-components";

import { themes } from "@olist/design-system-tokens";

interface BlueTargetProps {
  width?: string;
  height?: string;
  rectFill?: string;
  pathFill?: string;
}

const Svg = styled.svg`
  display: inline-block;
  vertical-align: middle;
`;

export function BlueTarget({
  height = "56",
  pathFill = "white",
  rectFill = themes.olist.base.color.primary.base,
  width = "57",
}: BlueTargetProps) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 57 56"
      fill="none"
    >
      <rect x="8.75684" y="8" width="40" height="40" rx="20" fill={rectFill} />
      <path
        d="M28.7568 19C23.7865 19 19.7568 23.0297 19.7568 28C19.7568 32.9703 23.7865 37 28.7568 37C33.7271 37 37.7568 32.9703 37.7568 28C37.7568 23.0297 33.7271 19 28.7568 19ZM28.7568 32.4179C26.3168 32.4179 24.3374 30.4401 24.3374 27.9984C24.3374 25.5567 26.3152 23.5789 28.7568 23.5789C31.1969 23.5789 33.1763 25.5567 33.1763 27.9984C33.1763 30.4401 31.1969 32.4179 28.7568 32.4179Z"
        fill={pathFill}
      />
    </Svg>
  );
}
